import { Ong } from "./Ong";

export{
    Ong
}